import type { ReactNode } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

type DataSectionProps = {
  title?: string;
  isLoading?: boolean;
  isEmpty?: boolean;
  emptyText?: string;
  skeletonRows?: number;
  children?: ReactNode;
};

export const DataSection = (props: DataSectionProps) => {
  const {
    title,
    isLoading = false,
    isEmpty = false,
    emptyText,
    skeletonRows = 3,
    children,
  } = props;

  return (
    <section className="flex flex-col gap-2">
      {!!title && <h2 className="text-base font-semibold">{title}</h2>}
      {isLoading && (
        <div className="space-y-2">
          {Array.from({ length: skeletonRows }, (_, index) => (
            <Skeleton
              key={index}
              className="h-8 w-full"
            />
          ))}
        </div>
      )}
      {!isLoading && isEmpty && (
        <p className="text-muted-foreground text-sm">{emptyText}</p>
      )}
      {!isLoading && !isEmpty && children}
    </section>
  );
};
